
  import { Component, Vue } from 'vue-property-decorator'

  import { getLogoExternalUrl } from '@/helpers/Environment'

  @Component
  export default class extends Vue {
    get homeLinkAttributes(): {
      is: string
      [key: string]: string
    } {
      const externalUrl = getLogoExternalUrl()
      if (externalUrl) {
        return { is: 'a', href: externalUrl }
      } else {
        return { is: 'router-link', to: '/' }
      }
    }
  }
